"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applySimulationOverrides = exports.runCall = void 0;
const utils_1 = require("@ganache/utils");
const ethereum_address_1 = require("@ganache/ethereum-address");
const message_1 = __importDefault(require("@ethereumjs/vm/dist/evm/message"));
const ethereumjs_util_1 = require("ethereumjs-util");
const evm_1 = __importDefault(require("@ethereumjs/vm/dist/evm/evm"));
const ethereumjs_util_2 = require("ethereumjs-util");
/**
 * Executes a message/transaction against the vm.
 * @param vm -
 * @param transaction -
 * @param gasLeft -
 * @returns
 */
function runCall(vm, transaction, gasLeft) {
    const caller = { buf: transaction.from.toBuffer() };
    const to = transaction.to == null ? undefined : { buf: transaction.to.toBuffer() };
    const value = new ethereumjs_util_1.BN(transaction.value == null ? 0 : transaction.value.toBuffer());
    const txContext = {
        gasPrice: new ethereumjs_util_1.BN(transaction.gasPrice.toBuffer()),
        origin: caller
    };
    const message = new message_1.default({
        caller,
        gasLimit: new ethereumjs_util_1.BN(utils_1.Quantity.toBuffer(gasLeft)),
        to,
        value,
        data: transaction.data && transaction.data.toBuffer()
    });
    const evm = new evm_1.default(vm, txContext, transaction.block);
    return evm.executeMessage(message);
}
exports.runCall = runCall;
const validateStorageOverride = (slot, value, fieldName) => {
    // assume Quantity will handle other types, these are just special string cases
    if (typeof slot === "string" && slot !== "" && slot.indexOf("0x") === 0) {
        // assume we're starting with 0x cause Quantity will verify if not
        if (slot.length != 66) {
            throw new Error(`${fieldName} override slot must be a 64 character hex string. Received ${slot.length - 2} character string.`);
        }
    }
    if (value === null || value === undefined) {
        throw new Error(`${fieldName} override data not valid. Received: ${value}`);
    }
    // assume Quantity will handle other types, these are just special string cases
    if (typeof value === "string" && value !== "" && value.indexOf("0x") === 0) {
        if (value.length != 66) {
            throw new Error(`${fieldName} override data must be a 64 character hex string. Received ${value.length - 2} character string.`);
        }
    }
};
async function applySimulationOverrides(stateTrie, vm, overrides) {
    const stateManager = vm.stateManager;
    for (const address in overrides) {
        if (!(0, utils_1.hasOwn)(overrides, address))
            continue;
        const { balance, nonce, code, state, stateDiff } = overrides[address];
        const vmAddr = { buf: ethereum_address_1.Address.from(address).toBuffer() };
        // group together overrides that update the account
        if (nonce != null || balance != null || code != null) {
            const account = await stateManager.getAccount(vmAddr);
            if (nonce != null) {
                account.nonce = {
                    toArrayLike: () => 
                    // geth treats empty strings as "0x0" nonce for overrides
                    nonce === "" ? utils_1.BUFFER_EMPTY : utils_1.Quantity.toBuffer(nonce)
                };
            }
            if (balance != null) {
                account.balance = {
                    toArrayLike: () => 
                    // geth treats empty strings as "0x0" balance for overrides
                    balance === "" ? utils_1.BUFFER_EMPTY : utils_1.Quantity.toBuffer(balance)
                };
            }
            if (code != null) {
                // geth treats empty strings as "0x" code for overrides
                const codeBuffer = utils_1.Data.toBuffer(code === "" ? "0x" : code);
                // The ethereumjs-vm StateManager does not allow to set empty code,
                // therefore we will manually set the code hash when "clearing" the contract code
                const codeHash = codeBuffer.length > 0 ? (0, utils_1.keccak)(codeBuffer) : ethereumjs_util_2.KECCAK256_NULL;
                account.codeHash = codeHash;
                await stateTrie.db.put(codeHash, codeBuffer);
            }
            await stateManager.putAccount(vmAddr, account);
        }
        // group together overrides that update storage
        if (state || stateDiff) {
            if (state) {
                // state and stateDiff fields are mutually exclusive
                if (stateDiff) {
                    throw new Error("both state and stateDiff overrides specified");
                }
                // it's possible that the user fed an override with a valid address
                // and slot, but not a value we can actually set in the storage. if
                // so, we don't want to set the storage, and we also don't want to
                // clear it out
                let clearedState = false;
                for (const slot in state) {
                    if (!(0, utils_1.hasOwn)(state, slot))
                        continue;
                    const value = state[slot];
                    validateStorageOverride(slot, value, "State");
                    if (!clearedState) {
                        // override.state clears all storage and sets just the specified slots
                        await stateManager.clearContractStorage(vmAddr);
                        clearedState = true;
                    }
                    const slotBuf = utils_1.Data.toBuffer(slot, 32);
                    const valueBuf = utils_1.Data.toBuffer(value);
                    await stateManager.putContractStorage(vmAddr, slotBuf, valueBuf);
                }
            }
            else {
                for (const slot in stateDiff) {
                    // don't set storage for invalid values
                    if (!(0, utils_1.hasOwn)(stateDiff, slot))
                        continue;
                    const value = stateDiff[slot];
                    validateStorageOverride(slot, value, "StateDiff");
                    const slotBuf = utils_1.Data.toBuffer(slot, 32);
                    const valueBuf = utils_1.Data.toBuffer(value);
                    await stateManager.putContractStorage(vmAddr, slotBuf, valueBuf);
                }
            }
        }
    }
}
exports.applySimulationOverrides = applySimulationOverrides;
//# sourceMappingURL=run-call.js.map